import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import Layout from '../components/layout/Layout';
import { blogPosts } from '../data/mock';
import StarburstDecor from '../components/ui/StarburstDecor';

const BlogsPage = () => {
  return (
    <Layout>
      {/* Hero */}
      <section className="bg-white py-16 relative">
        <div className="container-main">
          <div className="max-w-2xl">
            <h1 className="text-4xl md:text-5xl font-bold text-navy leading-tight">
              Our Blog
            </h1>
            <p className="mt-6 text-gray-600">
              Insights, trends, and stories from our creative team.
            </p>
          </div>
          <div className="absolute top-8 right-8 hidden lg:block">
            <StarburstDecor size={100} />
          </div>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="bg-white py-12">
        <div className="container-main">
          <div className="grid md:grid-cols-2 gap-8">
            {blogPosts.map((post) => (
              <Link
                key={post.id}
                to={`/blogs/${post.id}`}
                className="group"
              >
                <div className="aspect-video rounded-xl overflow-hidden mb-4">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex items-center gap-4 mb-2">
                  <span className="text-xs font-medium px-3 py-1 bg-lime text-navy rounded-full">
                    {post.category}
                  </span>
                  <span className="text-sm text-gray-500">{post.date}</span>
                </div>
                <h3 className="text-xl font-semibold text-navy group-hover:text-lime transition-colors">
                  {post.title}
                </h3>
                <p className="text-gray-600 text-sm mt-2">{post.excerpt}</p>
                <span className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-navy group-hover:text-lime transition-colors">
                  Read More
                  <ArrowUpRight className="w-4 h-4" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default BlogsPage;
